module.exports = __webpack_public_path__ + "img/guessruleicon.2772c5b1.png";